export function PrivacyPage() {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F9FAFB', padding: '40px 20px' }}>
      <div style={{ maxWidth: 800, margin: '0 auto', backgroundColor: 'white', borderRadius: 16, padding: '40px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
        
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 32 }}>
          <img src="/favicon.svg" alt="logo" style={{ width: 40, height: 40 }} />
          <div>
            <h1 style={{ margin: 0, fontSize: 24, fontWeight: 800, color: '#111827' }}>Privacy Policy</h1>
            <p style={{ margin: 0, fontSize: 13, color: '#6B7280' }}>Study Planner Schedule — Ultimo aggiornamento: 8 aprile 2026</p>
          </div>
        </div>

        {[
          {
            title: '1. Titolare del trattamento',
            content: 'Il titolare del trattamento dei dati personali è Study Planner Schedule (studyplannerschedule@gmail.com). Per qualsiasi richiesta relativa alla privacy, puoi contattarci a studyplannerschedule@gmail.com.'
          },
          {
            title: '2. Dati raccolti',
            content: 'Raccogliamo i seguenti dati personali: indirizzo email e nome (forniti durante la registrazione tramite Google o email/password), dati di utilizzo dell\'app (piani di studio creati, progressi), dati di pagamento (gestiti da Stripe — non conserviamo i dati della carta di credito).'
          },
          {
            title: '3. Finalità del trattamento',
            content: 'I dati vengono utilizzati per: fornire il servizio di pianificazione dello studio, gestire l\'account e l\'abbonamento Premium, migliorare il servizio tramite dati aggregati e anonimi, inviare comunicazioni relative al servizio.'
          },
          {
            title: '4. Base giuridica',
            content: 'Il trattamento dei dati è basato su: esecuzione del contratto (art. 6.1.b GDPR) per la fornitura del servizio, consenso dell\'utente (art. 6.1.a GDPR) per comunicazioni marketing, legittimo interesse (art. 6.1.f GDPR) per il miglioramento del servizio.'
          },
          {
            title: '5. Conservazione dei dati',
            content: 'I dati vengono conservati per tutta la durata dell\'account attivo. Alla cancellazione dell\'account, i dati vengono eliminati entro 30 giorni, salvo obblighi di legge.'
          },
          {
            title: '6. Condivisione dei dati',
            content: 'I dati non vengono venduti a terzi. Vengono condivisi solo con: Supabase (database e autenticazione), Stripe (pagamenti), Google (autenticazione Google OAuth e Analytics).'
          },
          {
            title: '7. Diritti dell\'utente',
            content: 'Hai il diritto di: accedere ai tuoi dati, rettificarli, cancellarli ("diritto all\'oblio"), portarli (data portability), opporti al trattamento. Per esercitare questi diritti, contattaci a studyplannerschedule@gmail.com.'
          },
          {
            title: '8. Cookie',
            content: 'Utilizziamo cookie tecnici necessari per il funzionamento del servizio e cookie analitici (Google Analytics) per migliorare l\'esperienza utente. Puoi disabilitare i cookie analitici nelle impostazioni del browser.'
          },
          {
            title: '9. Sicurezza',
            content: 'I dati sono protetti con crittografia SSL/TLS. L\'accesso al database è protetto da Row Level Security (RLS) di Supabase. I dati di pagamento sono gestiti da Stripe con standard PCI DSS.'
          },
          {
            title: '10. Contatti',
            content: 'Per qualsiasi domanda sulla privacy: studyplannerschedule@gmail.com'
          }
        ].map(section => (
          <div key={section.title} style={{ marginBottom: 24 }}>
            <h2 style={{ fontSize: 16, fontWeight: 700, color: '#111827', marginBottom: 8 }}>{section.title}</h2>
            <p style={{ fontSize: 14, color: '#4B5563', lineHeight: 1.7, margin: 0 }}>{section.content}</p>
          </div>
        ))}

        <div style={{ marginTop: 40, paddingTop: 24, borderTop: '1px solid #E5E7EB', textAlign: 'center' }}>
          <a href="/" style={{ color: '#1c3fff', textDecoration: 'none', fontSize: 14, fontWeight: 600 }}>← Torna all\'app</a>
        </div>
      </div>
    </div>
  )
}
